import { rankCol, playerCol, divCol, teamCol, teamNameCol, confCol, yearCol, round1Col, numCol, warCol, sosAdjWarCol } from "./helpers";

const valueStats = [
  round1Col("WPA", "wpa"),
  round1Col("+WPA", "pos_wpa"),
  round1Col("-WPA", "neg_wpa"),
  round1Col("RE24", "rea"),
  round1Col("REW", "rew"),
  round1Col("pLI", "pli"),
  round1Col("WPA/LI", "wpa_li"),
  round1Col("Clutch", "clutch"),
];

export const columnsValueBatter = [
  rankCol(), playerCol(), teamCol(), confCol(), divCol(), yearCol(),
  warCol(), sosAdjWarCol(),
  ...valueStats,
];

export const columnsValuePitcher = [
  rankCol(), playerCol(), teamCol(), confCol(), divCol(), yearCol(),
  warCol(), sosAdjWarCol(),
  ...valueStats,
];

export const columnsValueBattingTeam = [
  rankCol(), teamNameCol(), confCol(), divCol(), yearCol(),
  warCol(), sosAdjWarCol(),
  ...valueStats,
];

export const columnsValuePitchingTeam = [
  rankCol(), teamNameCol(), confCol(), divCol(), yearCol(),
  warCol(), sosAdjWarCol(),
  ...valueStats,
  numCol("Pulls", "pitching_changes"),
];
